var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.885742 9C1.59074 5.16 4.95599 2.25 8.99999 2.25C13.044 2.25 16.4085 5.16 17.1142 9C16.4092 12.84 13.044 15.75 8.99999 15.75C4.95599 15.75 1.59149 12.84 0.885742 9ZM8.99999 12.75C9.99455 12.75 10.9484 12.3549 11.6516 11.6517C12.3549 10.9484 12.75 9.99456 12.75 9C12.75 8.00544 12.3549 7.05161 11.6516 6.34835C10.9484 5.64509 9.99455 5.25 8.99999 5.25C8.00543 5.25 7.0516 5.64509 6.34834 6.34835C5.64508 7.05161 5.24999 8.00544 5.24999 9C5.24999 9.99456 5.64508 10.9484 6.34834 11.6517C7.0516 12.3549 8.00543 12.75 8.99999 12.75ZM8.99999 11.25C8.40326 11.25 7.83096 11.0129 7.409 10.591C6.98704 10.169 6.74999 9.59674 6.74999 9C6.74999 8.40326 6.98704 7.83097 7.409 7.40901C7.83096 6.98705 8.40326 6.75 8.99999 6.75C9.59673 6.75 10.169 6.98705 10.591 7.40901C11.0129 7.83097 11.25 8.40326 11.25 9C11.25 9.59674 11.0129 10.169 10.591 10.591C10.169 11.0129 9.59673 11.25 8.99999 11.25Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeImg);
export default __webpack_public_path__ + "static/media/eyeImg.59a71779f317016af388e8d57fbda61f.svg";
export { ForwardRef as ReactComponent };